"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsoCodeSelectList = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const Input_1 = require("./Input");
const IsoCodeSelectList = (props) => {
    const [list, setList] = (0, react_1.useState)([]);
    const { data: isobundesland = [], isLoading } = props.useGetBundeslandQuery();
    (0, react_1.useEffect)(() => {
        let tmp = [];
        if (isLoading) {
            tmp = [{ value: 0, label: 'Lädt' }];
        }
        else {
            isobundesland.forEach((key) => {
                tmp.push({
                    value: key.id,
                    // label: key.code + ': ' + key.name,
                    label: key.name,
                });
            });
        }
        setList(tmp);
    }, [isLoading]);
    return ((0, jsx_runtime_1.jsx)(Input_1.Input, { edit: true, name: props.name ? props.name : 'iso_code_countys', dropdownOptions: list, scrollHeight: '350px', type: 'dropdown', label: props.label, value: props.value, onChange: (e) => {
            if (props.setValue)
                props.setValue(e.value);
            if (props.onChange)
                props.onChange(e);
        }, validationControl: props.validationControl, validationErrorMessage: props.validationErrorMessage, validationRules: props.validationRules }));
};
exports.IsoCodeSelectList = IsoCodeSelectList;
